import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { ComponentRegistry } from 'core';
import { goBack } from 'core/routing';
import { staticURL } from 'core/url';

import { Wizard } from 'libs/wizards/index';
import DocumentHead from 'legacyComponents/documentHead';

import { ProjectTypeOption } from 'apps/project/views/projectTypeOption';
import { ProjectTypeItem } from 'apps/project/views/projectTypeItem';
import { ImportProjectAppManager } from 'apps/project/importProject/appManager';
import { clientStore } from 'apps/client/app';

import Logo from 'components/Logo';
import Button from 'components/Button';
import Image from 'components/Image';

import {
  MainSignInPageWrapper,
  ImageWrapper,
  GoBackWrapper,
  WrapperSignInForm,
  MainSignInFormColumn,
} from 'apps/signIn/styles';

ComponentRegistry.add('project.projectTypeOption', ProjectTypeOption);
ComponentRegistry.add('project.projectTypeItem', ProjectTypeItem);

@withNamespaces()
@observer
export class ImportProject extends React.Component {
  constructor(props) {
    super(props);
    if (clientStore.signedInProfile) {
      this.appManager = new ImportProjectAppManager(null, {});
    } else {
      clientStore.routerStore.navigate(
        'home.signIn',
        {
          next: clientStore.next(),
        },
        {
          replace: true,
        },
      );
    }
  }

  render() {
    const { t } = this.props;
    if (!this.appManager) return null;

    return (
      <>
        <DocumentHead title={`${t('Import Project')}`} index='noindex' />
        <MainSignInPageWrapper>
          <GoBackWrapper>
            <Button
              outline
              variant='minimal'
              icon='close_small'
              size='small'
              onClick={() => goBack()}
            />
          </GoBackWrapper>
          <ImageWrapper>
            <Image
              src={staticURL('assets/gridImages/yellow-triangle.svg')}
              alt='Grid image'
            />
          </ImageWrapper>
          <WrapperSignInForm>
            <MainSignInFormColumn>
              <Logo size='48px' />
              <Wizard
                isSideBarForm
                spacing='medium'
                wizard={this.appManager.wizard}
              />
            </MainSignInFormColumn>
          </WrapperSignInForm>
        </MainSignInPageWrapper>
      </>
    );
  }
}

ImportProject.propTypes = {
  t: PropTypes.func,
};
